export class FooterComponent implements ng.IComponentOptions {
    public template: string =
    `
      <div class="footer">
        <div>
          <img src=${require("../../../../images/mohr.png")} />
          <ul>
            <li><a href="#/about">About LMIDW</a></li>
            <li><a href="#/term">Term of Use</a></li>
            <li><a href="#/privacy">Privacy Policy</a></li>
          </ul>
          <ul>
            <li><a href="#/dataPolicy">Data Policy</a></li>
            <li><a href="#/disclaimer">Disclaimer</a></li>
          </ul>
          <div class="address">
          <p>Contact Information:</p>
          <p style="line-height:1.3">
            Institute of Labour Market Information and Analysis (ILMIA)<br/>
            Ministry of Human Resources (MOHR)<br/>
            G07-G12, Ground Floor, Right Wing, Block 2320,<br/>
            Century Square, Cyber 6, Jalan Usahawan,<br/>
            63000 Cyberjaya, Selangor.<br/>
            Tel.No: 03-83182433&nbsp;&nbsp;Fax.No: 03-83180709<br/>
            Website: http://www.ilmia.gov.my<br/>
          </div>
        </div>
      </div>`;
}
